<template>
  <el-popover
    placement="bottom"
    popper-class="bg-lightgrey"
    width="260"
    trigger="click"
    :title="label"
  >
    <p style="font-size: 11px" v-if="content" v-html="$options.filters.wrapURL(content)"></p>
    <i
      v-if="content"
      class="has-text-dark el-icon-question"
      slot="reference"
      style="margin-left: 0.5em"
    />
  </el-popover>
</template>

<script>
/**
 * ModuleEditorTooltip - Help icon with popover for SmartField descriptions.
 *
 * @component
 * @description Displays a question mark icon that shows a popover with help text when clicked.
 * Automatically detects and converts URLs in content to clickable links. Conditionally renders
 * only when content is provided.
 *
 * @prop {string} label - Tooltip title/header
 * @prop {string} content - Help text content (supports HTML, auto-linkifies URLs)
 *
 * @example
 * <Tooltip
 *   label="API Key"
 *   content="Enter your API key from the developer portal: https://developer.example.com"
 * />
 */
export default {
  props: ["label", "content"],
};
</script>
